// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"n1","legalMessage":"n2","navLink":"n3","bottomLinkWrapper":"n4","bottomLink":"n5 n3"};